import styled from 'styled-components'

const MyDiv = styled.div`
    .no-data-box{
        margin: 50px 0px;
    }
    .no-data-box h4{
        border: 1px dashed #667085;
        display: inline-block;
        padding: 10px 20px;
        border-radius: 4px;
    }
`
export default MyDiv